import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const StaffLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg(null);

    try {
      const res = await fetch(`${API_URL}/api/staff/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const json = await res.json();

      if (!res.ok) {
        setErrorMsg("Identifiants incorrects ou vous n'avez pas l'accès.");
        return;
      }

      localStorage.setItem('staff_token', json.token);
      navigate('/staff/scanner');

    } catch (error) {
      console.error(error);
      setErrorMsg("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container" style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>

      <div className="form-panel" style={{ border: '1px solid #eaeaea', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
          <img src="/assets/Logo/Logo final.png" alt="Durden Logo" style={{ height: '3rem', filter: 'brightness(0)', opacity: 0.8 }} />
        </div>

        <h1 className="form-title" style={{ fontSize: '1.5rem', marginBottom: '2rem' }}>Accès Staff</h1>

        {errorMsg && <div className="global-error">{errorMsg}</div>}

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label className="input-label">Email Staff</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="form-input"
              required
            />
          </div>
          <div className="input-group">
            <label className="input-label">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="form-input"
              required
            />
          </div>

          <button type="submit" disabled={loading} className="btn-secondary">
            {loading ? <div className="spinner" style={{ borderColor: '#000', borderTopColor: 'transparent' }}></div> : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default StaffLogin;
